/* OceAura month packs (cold-traffic offer B): 1 ₪99, 2 ₪169, 3 ₪199, 5+oil ₪299. Generated from the oceaura-cold-internal product. */
window.OCEASALE_VARIANT_MAP=Object.freeze({"OCEASALE-1-1-0":"52131572678951","OCEASALE-2-2-0":"52131572711719","OCEASALE-3-3-0":"52131572744487","OCEASALE-5-5-1":"52131572777255"});
